(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tab-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const tabs = document.querySelectorAll('.custom-tab');  // All <h6> tab headings
    const tabContents = document.querySelectorAll('.custom__tab-content');  // All tab content sections

    // Set the first tab heading and content to be active by default
    tabs[0].classList.add('active');
    tabContents[0].classList.add('active');

    // Add click event listener to each tab
    tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
            // Remove the 'active' class from all tabs and contents
            tabs.forEach(function(tab) {
                tab.classList.remove('active');
            });
            tabContents.forEach(function(content) {
                content.classList.remove('active');
            });

            // Add the 'active' class to the clicked tab and corresponding content
            this.classList.add('active');
            tabContents[index].classList.add('active');
        });
    });
});


  } catch(e) { console.error(e); }
})();
})();
